import { Link } from 'react-router-dom';

const steps = ['ИПР сотрудников', 'Общие дефициты компетенций', 'Группы сотрудников', 'Корпоративная программа обучения'];

export default function IPRAndCorporateTraining() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          ИПР и корпоративное обучение
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          Как результаты индивидуальных планов помогают компании строить обучение
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          {steps.map((step, i, arr) => (
            <div key={step} className="flex items-center gap-3">
              <span className="bg-white border border-teal-200 text-teal-700 px-4 py-2 rounded-lg text-sm font-semibold">
                {step}
              </span>
              {i < arr.length - 1 && <i className="ri-arrow-right-line text-teal-600"></i>}
            </div>
          ))}
        </div>

        <div className="space-y-4 mb-12">
          <div className="bg-white rounded-xl border border-gray-200 p-5">
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Если у 20 руководителей обнаруживается общий дефицит в постановке задач и обратной связи, компания может организовать корпоративный тренинг.
            </p>
          </div>
          <div className="bg-white rounded-xl border border-gray-200 p-5">
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              Если проблема характерна только для нескольких руководителей, эффективнее может быть индивидуальная работа.
            </p>
          </div>
        </div>

        <p className="text-base md:text-lg text-gray-700 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          Таким образом ИПР помогает соединить индивидуальное и корпоративное развитие.
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/enciklopediya-korporativnogo-obucheniya/obuchenie-personala" className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Обучение персонала
          </Link>
          <Link to="/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya" className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Корпоративная академия
          </Link>
          <Link to="/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya" className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Разработка программ обучения
          </Link>
        </div>
      </div>
    </section>
  );
}